import React, { useState, useCallback, useRef } from 'react'

import { ColorBox, ColorButton, createColor } from 'material-ui-color'
import PropTypes from 'prop-types'

import Popover from '@material-ui/core/Popover'

import colors from '@galo-monitor/styles/colors'
import TextField from '@galo-monitor/web-components/TextField'

const InputColor = (props) => {
  const { onChange, ...rest } = props

  const refPicker = useRef(null)
  const fieldRef = useRef(null)

  const [color, setColor] = useState(createColor(rest.defaultValue ?? colors.primary))
  const [open, setOpen] = useState(false)

  const handleClick = useCallback(() => {
    const b = Boolean(refPicker.current)
    setOpen(b)
  }, [])

  const handleChange = useCallback(colorValue => {
    if (!rest.detached && fieldRef.current) {
      fieldRef.current.setValue(`#${ colorValue.hex }`)
    }
    setColor(colorValue)
    onChange(`#${ colorValue.hex }`)
  }, [onChange, rest.detached])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  const handleTextFieldChange = useCallback(event => {
    const { value: fieldValue } = event.target
    setColor(createColor(fieldValue))
    onChange(fieldValue)
  }, [onChange])

  return (
    <div ref={ refPicker } style={ { display: 'flex', alignItems: 'center', gap: 10 } }>
      <ColorButton
        size={ 35 }
        color={ color }
        onClick={ handleClick }
      />
      <Popover
        id="input-color-popover"
        open={ open }
        anchorEl={ refPicker.current }
        onClose={ handleClose }
        anchorOrigin={ {
          vertical: 'bottom',
          horizontal: 'center'
        } }
        transformOrigin={ {
          vertical: 'top',
          horizontal: 'center'
        } }
      >
        <ColorBox
          value={ color }
          style={ { position: 'relative' } }
          onChange={ handleChange }
        />
      </Popover>
      <TextField
        ref={ fieldRef }
        onChange={ handleTextFieldChange }
        style={ { margin: 0 } }
        { ...rest }
        type="text"
      />
    </div>
  )
}

InputColor.propTypes = {
  detached: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func
}

InputColor.defaultProps = {
  detached: false,
  value: null,
  defaultValue: null,
  onChange: () => {}
}

export default InputColor
